'use client';

import { createContext } from 'react';

export const SmartCaptchaDialogContext = createContext({
  challengeVisible: false,
  busy: false,
  close: () => {},
  setChallengeVisible: (_visible: boolean) => {},
});
